import "@/styles/globals.css";
import type { AppProps } from "next/app";
import Image from "next/image";
import { LoaderProvider } from "@/contexts/LoaderContext";
import GlobalLoader from "@/components/GlobalLoader";
import LogoutButton from "@/components/LogoutButton";
import styles from "@/styles/App.module.css";
import Head from "next/head";
import { useRouter } from "next/router";

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const isLoginPage = router.pathname === '/login';

  return (<>
    <Head>
      <title>Dollar Day</title>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="icon" href="/favicon.ico" />
    </Head>
    <LoaderProvider>
      <GlobalLoader />
      <header className={styles.header}>
        <div className={`${styles.headerContainer} container `}>
          <Image src="/assets/images/ddlogo.png" alt="DD Logo" width={300} height={120} className={styles.logo} />
          <div className={styles.rightSection}>
            <Image src="/assets/images/logo.png" alt="Logo" width={150} height={50} className={styles.logo} />
          </div>
        </div>
            {!isLoginPage && <LogoutButton />}
      </header>
      <Component {...pageProps} />
    </LoaderProvider>
  </>
  );
}
